import { useNovaApi } from '../useNovaApi';

export const useUniversalCategorySelect = () => {
  return (
    useNovaApi<Nl.Api.UniversalCategorySelectResponse>(
      '/universal_category/select',
    ).data?.universal_categories || []
  );
};
